/**
 * Activity Timeline / Daily Pulse Configuration
 *
 * Centralized, extensible definition for timeline states:
 * - ACTIVE: Productive active session time
 * - IDLE: Inactivity / idle session time
 * - LUNCH_BREAK: Meal break window (between logout & login)
 * - BREAK: Short / coffee / tea break window
 */

export const TIMELINE_STATES = Object.freeze({
  ACTIVE: {
    key: 'ACTIVE',
    label: 'Active',
    barClass: 'bg-primary',
    badgeClass: 'bg-blue-100 text-blue-800',
    dotClass: 'bg-blue-600',
  },
  IDLE: {
    key: 'IDLE',
    label: 'Idle',
    barClass: 'bg-surface-container-high',
    badgeClass: 'bg-slate-100 text-slate-700',
    dotClass: 'bg-slate-500',
  },
  LUNCH_BREAK: {
    key: 'LUNCH_BREAK',
    label: 'Lunch Break',
    barClass: 'bg-amber-500',
    badgeClass: 'bg-amber-100 text-amber-800',
    dotClass: 'bg-amber-600',
  },
  BREAK: {
    key: 'BREAK',
    label: 'Break',
    barClass: 'bg-sky-500',
    badgeClass: 'bg-sky-100 text-sky-800',
    dotClass: 'bg-sky-600',
  },
})

export const ALLOWED_TIMELINE_STATES = Object.keys(TIMELINE_STATES)

export function getTimelineStateConfig(state) {
  const normalized = String(state || '').toUpperCase()
  return (
    TIMELINE_STATES[normalized] || {
      key: normalized,
      label: normalized || 'Unknown',
      barClass: 'bg-surface-container-high',
      badgeClass: 'bg-surface-container-high text-on-surface-variant',
      dotClass: 'bg-outline',
    }
  )
}

export function formatTimelineTooltip(segment) {
  const config = getTimelineStateConfig(segment?.state)
  const timeRange = segment?.startTime && segment?.endTime ? `${segment.startTime} - ${segment.endTime}` : ''
  const duration = segment?.durationLabel ? ` (${segment.durationLabel})` : ''
  return `${config.label}: ${timeRange}${duration}`
}
